import './styles.scss';
import { createApp } from 'vue';
import App from './App.vue';
import { i18n } from './composables/useI18n';
import { router } from './router';
import { init } from '@sentry/vue';
import env from '@/config';
import config from '@/config';
import '@material/web/all.js';
import { VueQueryPlugin } from '@tanstack/vue-query';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const themeLink = document.querySelector('#theme-link') as HTMLLinkElement;

themeLink.href = config.THEME_FILE;

const app = createApp(App).use(i18n).use(Vue3Toastify);

init({
  app,
  dsn: env.SENTRY_DSN,
  environment: env.ENVIRONMENT,
  release: process.env.VUE_APP_VERSION,
});

app
  .use(router)
  .use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          retry: 1,
          refetchOnWindowFocus: false,
        },
      },
    },
  })
  .mount('#app');
